<div class="alert alert-danger mb-2" role="alert" *ngIf="mensagemErro">
  <i class="fas fa-exclamation-triangle"></i>
  {{mensagemErro}}
  <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" (click)="fecheMensagemErro()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form id="frmGetnet" [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
      novalidate #frm="ngForm" class="form-cartao-getnet">
  <div class="card card-dados-cartao mt-2">
    <div class="card-body">
      <div class="bloqueio" *ngIf="carregando">
        <div class="loading-content">
          <div class="k-icon k-i-loading"></div>
          <div class="loading-text">{{mensagemCarregamento}}</div>
        </div>
      </div>

      <h5 class="titulo-secao-cartao">Dados do cartão</h5>

      <div class="box-dados-cartao">
        <div class="intro-cartao">
          <div class="icone-intro-cartao">
            <i class="fas fa-credit-card"></i>
          </div>
          <div>
            <strong>Insira os dados do seu cartão</strong>
            <span>Preencha os campos abaixo com as informações do seu cartão.</span>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="numeroGetnet">Número do cartão</label>
              <div class="campo-cartao com-icone">
                <i class="fas fa-credit-card card-icon"></i>
                <input type="text" class="form-control input-background" autocomplete="off"
                       [mask]="'0000-0000-0000-0009'"
                       id="numeroGetnet" name="numeroGetnet" [(ngModel)]="cartao.numero"
                       #numeroGetnet="ngModel" appAutoFocus required placeholder="0000-0000-0000-0000">
                <i class="far fa-credit-card card-icon direita"></i>
              </div>
              <div class="invalid-feedback">
                <p *ngIf="numeroGetnet.errors?.required">Número do cartão é obrigatório</p>
                <p *ngIf="numeroGetnet.errors?.mask">Número do cartão inválido.</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-12">
            <div class="form-group">
              <label for="nomeGetnet">Nome do titular</label>
              <div class="campo-cartao com-icone">
                <i class="fas fa-user card-icon"></i>
                <input type="text" class="form-control" autocomplete="off" required
                       id="nomeGetnet" name="nomeGetnet" [(ngModel)]="cartao.nome"
                       #nomeGetnet="ngModel" placeholder="Nome como está no cartão">
              </div>
              <div class="invalid-feedback">
                <p *ngIf="nomeGetnet.errors?.required">Nome do titular é obrigatório</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-12">
            <div class="form-group">
              <label for="cpfGetnet">CPF do titular</label>
              <div class="campo-cartao com-icone">
                <i class="far fa-id-card card-icon"></i>
                <input type="text" class="form-control" autocomplete="off" required
                       id="cpfGetnet" name="cpfGetnet" [(ngModel)]="cartao.cpf"
                       #cpfGetnet="ngModel" mask="000.000.000-00" cpfValido
                       placeholder="000.000.000-00">
              </div>
              <div class="invalid-feedback">
                <p *ngIf="cpfGetnet.errors?.required">Obrigatório</p>
                <p *ngIf="cpfGetnet.errors?.cpfInvalido">CPF é inválido</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-6">
            <div class="form-group">
              <label for="validadeGetnet">Validade</label>
              <div class="campo-cartao com-icone">
                <i class="far fa-calendar-alt card-icon"></i>
                <kendo-dateinput name="validadeGetnet" id="validadeGetnet" format="MM/yy"
                                 class="form-control" required #validadeGetnet="ngModel"
                                 [(ngModel)]="cartao.validade">
                </kendo-dateinput>
              </div>
              <div class="invalid-feedback">
                <p *ngIf="validadeGetnet.errors?.required">Validade é obrigatória</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-6">
            <div class="form-group">
              <label for="cvvGetnet">Código segurança (CVV)</label>
              <div class="campo-cartao com-icone">
                <i class="fas fa-lock card-icon"></i>
                <input type="text" class="form-control" autocomplete="off" [mask]="'0009'"
                       id="cvvGetnet" name="cvvGetnet" [(ngModel)]="cartao.cvv"
                       #cvvGetnet="ngModel" placeholder="000" required>
                <i class="far fa-question-circle card-icon direita"></i>
              </div>
              <div class="invalid-feedback">
                <p *ngIf="cvvGetnet.errors?.required">CVV é obrigatório</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-12">
            <div class="form-group">
              <label for="tipoCartaoGetnet">Tipo</label>
              <div class="campo-cartao com-icone">
                <i class="fas fa-exchange-alt card-icon"></i>
                <kendo-combobox id="tipoCartaoGetnet" name="tipoCartaoGetnet"
                                [(ngModel)]="cartao.tipoDoCartao"
                                [data]="tiposCartao"
                                [textField]="'descricao'"
                                [valueField]="'id'"
                                [valuePrimitive]="false"
                                [clearButton]="false"
                                required #tipoCartaoGetnet="ngModel"
                                class="form-control">
                </kendo-combobox>
              </div>
              <div class="invalid-feedback">
                <p *ngIf="tipoCartaoGetnet.errors?.required">Tipo do cartão é obrigatório</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-12">
            <div class="form-group">
              <label for="emailGetnet">Email</label>
              <div class="campo-cartao com-icone">
                <i class="fas fa-envelope card-icon"></i>
                <input kendoTextBox id="emailGetnet" name="emailGetnet" type="email" emailPagamentoValido
                       placeholder="Informe seu email" class="form-control"
                       [(ngModel)]="cartao.email" #emailGetnet="ngModel" required>
              </div>
              <div class="invalid-feedback">
                <p *ngIf="emailGetnet.errors?.required">Email é obrigatório</p>
                <p *ngIf="emailGetnet.errors?.email || emailGetnet.errors?.emailPagamentoInvalido">Informe um email válido.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="desafio-3ds-overlay" *ngIf="desafio3dsAberto">
  <div class="desafio-3ds-dialog" role="dialog" aria-modal="true" aria-label="Autenticação do banco">
    <div class="desafio-3ds-header">
      <div>
        <div class="desafio-3ds-title">Autenticacao do banco</div>
        <div class="desafio-3ds-subtitle">Conclua a verificacao para autorizar o cartao.</div>
      </div>

      <button type="button" class="desafio-3ds-close" aria-label="Cancelar autenticacao"
              (click)="cancelarDesafio3ds()">
        &times;
      </button>
    </div>

    <div class="desafio-3ds-frame-wrapper">
      <div class="desafio-3ds-loading" *ngIf="desafio3dsCarregando">
        <div class="k-icon k-i-loading"></div>
        <div>Carregando autenticacao...</div>
      </div>
      <div #containerDesafio3ds class="desafio-3ds-frame-container"></div>
    </div>
  </div>
</div>
